import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from '@common/components/base.component';
import navbarSelectors from '@common/store/navbar/navbar.selectors';
import navbarActions from '@common/store/navbar/navbar.actions';
import DateFormat from '@common/components/formats/date.format';
import SmartModal from '@common/components/modals/smartModal';
import { Modal, Row, Col } from 'react-bootstrap';

class NavbarAbout extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = { isLoad: false };
  }

  componentDidUpdate() {
    if (this.props.showAboutModal && !this.state.isLoad) {
      this.props.navbarActions.getInfoAbout();
      this.setState({ ...this.state, isLoad: true });
    }
  }

  styleInfo() {
    return {
      fontSize: '17px',
      color: '#383838',
      fontWeight: 'bold',
    };
  }

  styleValue() {
    return {
      fontSize: '15px',
    };
  }

  closeModal() {
    this.setState({ ...this.state, isLoad: false });
    this.props.onClose();
  }

  render() {
    const { showAboutModal } = this.props;
    const { Sistema, UltimaAtualizacao, VersaoApi, VersaoWebapp, Servidor, BancoDados } =
      this.props.navbarSelectors.about;

    return (
      <SmartModal show={showAboutModal} size="lg" backdrop="static" onHide={this.closeModal} keyboard>
        <Modal.Header>
          <Modal.Title>
            <h3>Sobre o Sistema</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col>
              <Row className="about-info">
                <span className="about-info-title">Sistema</span>
              </Row>

              <Row className="about-info">
                <span className="about-info-value">{Sistema}</span>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col>
              <Row className="about-info">
                <span className="about-info-title">Última Atualização</span>
              </Row>

              <Row className="about-info">
                <DateFormat value={UltimaAtualizacao} />
              </Row>
            </Col>

            <Col>
              <Row className="about-info">
                <span className="about-info-title">Versão (API)</span>
              </Row>

              <Row className="about-info">
                <span className="about-info-value">{VersaoApi}</span>
              </Row>
            </Col>

            <Col>
              <Row className="about-info">
                <span className="about-info-title">Versão (Webapp)</span>
              </Row>

              <Row className="about-info">
                <span className="about-info-value">{VersaoWebapp}</span>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col>
              <Row className="about-info">
                <span className="about-info-title">Servidor</span>
              </Row>

              <Row className="about-info">
                <span className="about-info-value">{Servidor}</span>
              </Row>
            </Col>

            <Col>
              <Row className="about-info">
                <span className="about-info-title">Banco de Dados</span>
              </Row>

              <Row className="about-info">
                <span className="about-info-value">{BancoDados}</span>
              </Row>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Row>
            <Col className="btn-forms">
              <button onClick={this.closeModal} className="btn btn-cancel">
                <i className="fa fa-times" /> Fechar
              </button>
            </Col>
          </Row>
        </Modal.Footer>
      </SmartModal>
    );
  }
}

export default connect({
  selectors: { navbarSelectors },
  actions: { navbarActions },
})(NavbarAbout);
